import { cn } from '@/lib/utils';

const map = {
  al_dia: { label: 'Al día', cls: 'pill-ok' },
  en_gracia: { label: 'En gracia', cls: 'pill-warn' },
  caducado: { label: 'Caducado', cls: 'pill-danger' },
} as const;

export function StatusPill({ value }: { value: 'al_dia' | 'en_gracia' | 'caducado' }) {
  const v = map[value];
  return <span className={cn(v.cls)}>{v.label}</span>;
}
